import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { containerHeight } from '../data';

export type ActionsContainerProps = Omit<BoxProps, 'children'>;

export const ActionsContainer = styled(Box)({
  height: containerHeight.action,
  padding: '20px 30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 12,
});
